<template>
  <div class="mx-auto max-w-2xl p-6 md:px-0 flex-1 self-center mb-32">
    <div class="py-6">
      <Logo height="26" class="mx-auto" />
    </div>
    <h1 class="text-lg mt-6 text-center">Bepaal de fases van je salespijplijn</h1>

    <div class="flex mx-auto items-center bg-blue-100 my-10 p-4 rounded">
      <img src="@/assets/smallbee-icons-all_smallbee-icon-pijplijn.svg" class="h-20 ml-1 mr-6" />
      <div>
        Dit zijn de fases die een
        <strong>pre-deal</strong> doorloopt voordat de deal rond is.
        <div>Je kunt dit later nog wijzigen onder instellingen.</div>
      </div>
    </div>

    <div class="mx-auto" style="max-width: 16rem;">
      <h2 class="mb-2">Dit zijn je fases:</h2>
      <div class="flex items-center mb-1" v-for="phase in phases" :key="phase.name">
        <PhaseBadge :phase="phase" />
        <button @click="removePhase(phase)" class="text-gray-400 hover:text-gray-900 mx-2">
          <BaseIcon name="x" size="16" />
        </button>
      </div>
      <div class="text-gray-500" v-if="phases.length == 0">Voeg minimaal 1 fase toe</div>
      <label class="mt-6 block">
        <span class="block mb-1">Nieuwe fase toevoegen</span>
        <div class="flex">
          <BaseInput
            class="flex-1 mr-2"
            name="new_phase"
            v-model="newPhase"
            maxlength="10"
            @keydown.enter="addPhase"
            placeholder="Max 10 tekens"
          />
          <button type="button" class="btn btn-gray px-3" @click.prevent="addPhase">
            <BaseIcon name="plus" />
          </button>
        </div>
      </label>
    </div>

    <div class="bg-gray-100 my-10 p-4 rounded text-center">
      <h2 class="mb-2">Je account is bijna klaar voor gebruik!</h2>
      <BaseButton
        class="btn btn-blue mb-2"
        type="button"
        @click.native="submit()"
        :submitting="submitting"
      >Opslaan en aan de slag</BaseButton>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import { post } from "@/api";
import Logo from "@/components/Logo";
import PhaseBadge from "@/components/PhaseBadge";

export default {
  components: {
    Logo,
    PhaseBadge
  },

  metaInfo() {
    return { title: "Ga aan de slag" };
  },

  data() {
    return {
      newPhase: "",
      submitting: false,
      form: {
        phases: ["Koud", "Lauw", "Warm"]
      }
    };
  },

  computed: {
    phases() {
      return this.form.phases.map((name, position) => {
        return {
          name,
          position
        };
      });
    }
  },

  beforeRouteEnter(to, from, next) {
    if (store.state.settings.is_onboarded) {
      next({ name: "dashboard" });
    } else {
      next();
    }
  },

  methods: {
    addPhase() {
      let phase = this.newPhase.trim();

      if (!phase) return;

      if (this.form.phases.length >= 6) {
        this.$store.commit("FLASH_ADD", {
          message: "Max 6 pijplijn fases",
          type: "warning"
        });
        return;
      }

      if (!this.form.phases.includes(phase)) {
        this.form.phases.push(phase);
      }

      this.newPhase = "";
    },

    removePhase(phase) {
      let index = this.form.phases.findIndex(s => s === phase.name);

      if (index >= 0) this.form.phases.splice(index, 1);
    },

    submit() {
      if (this.submitting) return;

      if (this.form.phases.length == 0) {
        this.$store.commit("FLASH_ADD", {
          message: "Voeg minimaal 1 fase toe",
          type: "warning"
        });
        return;
      }

      this.submitting = true;

      post("/onboarding", this.form)
        .then(response => {
          this.$store.commit("SET_SETTINGS", response.data);
          this.$router.push({ name: "dashboard" });
        })
        .finally(() => (this.submitting = false));
    }
  }
};
</script>
